<template>
    <div>
        <div v-for="(n, index) in contents"   :key="index" class="mb-8">
            <v-row class="mb-0">
                <v-col cols="6" md="2" v-if="n.Files[0]">
                    <v-card class="elevation-2">
                        <v-img
                        :src="`${$url}/downloadfile/${n.Files[0] ? n.Files[0].ID : ''}`"
                        class="transparent lighten-2"
                        >
                            <template v-slot:placeholder>
                            <v-layout
                                fill-height
                                align-center
                                justify-center
                                ma-0
                                >
                                <v-progress-circular indeterminate color="grey lighten-5"></v-progress-circular>
                            </v-layout>
                            </template>
                        </v-img>
                    </v-card>
                </v-col>
                <v-col cols="6" md="7">
                    <div class="d-flex align-center" style="height: 100%">
                        <p>
                            <a :href="`#/Join%20Us/${$route.params.contentType}/profile/${n.Title}`" class="title">{{n.Title.split(',').length > 0 ? n.Title.split(',')[0] : n.Title}}</a><br>
                            <span class="subheading text-xs-center">{{n.Title.split(', ')[1]}}</span>
                        </p>
                    </div>
                </v-col>
            </v-row>
            <!-- <p class="mt-3 text-xs-center"><a :href="`#/Join%20Us/${$route.params.contentType}/profile/${n.Title}`" class="title">{{n.Title}}</a></p> -->
            <i class="text-justify font-weight-medium" style="font-size: 20px" v-html="getQuote(n.Body)"></i>
        </div>
    </div>
</template>
<script>
    export default {
        props: ['contents'],
        methods: {
            getQuote (item) {
                let splitSentence = item.split('First page quotation')
                if (splitSentence.length > 1) {
                    const regex = /<\/[^>]+>/gi;
                    return splitSentence[1].replace(regex, ``)
                } else {
                    return ''
                }
             }
        }
    }
</script>